import {ChangeDetectorRef, Component, QueryList, ViewChildren} from '@angular/core';
import {ScheduledAnnouncement} from "../../entities/server/ScheduledAnnouncement";
import {APIService} from "../../services/APIService";
import {QuizQuestion, QuizQuestionAnswer} from "../../entities/quiz/QuizQuestion";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-quiz-list',
  templateUrl: './quiz-list.component.html',
  styleUrls: ['./quiz-list.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class QuizListComponent {
  questions: QuizQuestion[] = [];
  columns: string[] = ['id', 'questionText', 'category', 'actions'];
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<QuizQuestionAnswer>>;
  innerDisplayedColumns = ['id', 'answerText', 'correct', 'selectedCount', 'percentage'];
  expandedElement: QuizQuestion | null;
  currentQuestion: QuizQuestion | null;

  constructor(public apiService: APIService, private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.refreshQuestions();
  }

  refreshQuestions(){
    this.apiService.getQuizQuestions().then((a) => this.questions = a);
    this.apiService.getCurrentQuestion().then((a) => this.currentQuestion = a);
  }

  toggleRow(element: QuizQuestion) {
    element.answers && element.answers.length ? (this.expandedElement = this.expandedElement === element ? null : element) : null;
    this.cd.detectChanges();
  }

  async selectQuestion(event: Event, element: QuizQuestion) {
    event.stopPropagation();
    this.apiService.setCurrentQuestion(element.id).then((a) => {
      if(a){
        this.currentQuestion = a;
      }
    })
  }

  clearResponses(event: Event, element: QuizQuestion) {
    event.stopPropagation();
  }
  syncQuestions(event: Event) {
    this.apiService.syncQuestions().then(() => {
      this.refreshQuestions();
    })
  }
}
